import { render, staticRenderFns } from "./Vuetable.vue?vue&type=template&id=1f300bd3&scoped=true"
import script from "./Vuetable.vue?vue&type=script&lang=js"
export * from "./Vuetable.vue?vue&type=script&lang=js"
import style0 from "./Vuetable.vue?vue&type=style&index=0&id=1f300bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f300bd3",
  null
  
)

export default component.exports